<template>
  <div class="operators-multiselect" ref="wrapper">
    <!-- Trigger -->
    <div
      class="operators-trigger"
      @click="toggleDropdown"
      :class="{ open: showDropdown }"
    >
      <span v-if="modelValue.length === 0">Seleziona operatori</span>
      <span v-else
        >{{ modelValue.length }} operator{{
          modelValue.length > 1 ? "i" : "e"
        }}
        selezionat{{ modelValue.length > 1 ? "i" : "o" }}</span
      >
      <span class="operators-arrow">▾</span>
    </div>

    <!-- Dropdown con Teleport -->
    <Teleport to="body">
      <div
        v-if="showDropdown"
        ref="dropdown"
        class="operators-dropdown"
        :style="dropdownStyle"
        @mousedown.prevent
      >
        <label v-for="op in operators" :key="op.id" class="operators-option">
          <input
            type="checkbox"
            :value="op.id"
            :checked="modelValue.includes(op.id)"
            @change="onToggle(op.id)"
          />
          <span>{{ op.email }} (ID: {{ op.id }})</span>
        </label>
        <div v-if="operators.length === 0" class="operators-empty">
          Nessun operatore disponibile
        </div>
      </div>
    </Teleport>

    <!-- Tag rimuovibili -->
    <div v-if="modelValue.length > 0" class="operators-tags">
      <span v-for="id in modelValue" :key="id" class="operators-tag">
        {{ getEmail(id) }}
        <button
          type="button"
          class="operators-tag-remove"
          @click="removeOperator(id)"
        >
          ×
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OperatorsMultiSelect",
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showDropdown: false,
      triggerRect: null,
    };
  },
  computed: {
    dropdownStyle() {
      if (!this.triggerRect) return {};
      return {
        position: "fixed",
        top: `${this.triggerRect.bottom + 4}px`,
        left: `${this.triggerRect.left}px`,
        width: `${Math.max(this.triggerRect.width, 240)}px`,
        zIndex: 9999,
      };
    },
  },
  methods: {
    toggleDropdown() {
      if (this.showDropdown) {
        this.showDropdown = false;
      } else {
        this.updateTriggerRect();
        this.showDropdown = true;
      }
    },
    updateTriggerRect() {
      const trigger = this.$refs.wrapper?.querySelector(".operators-trigger");
      if (trigger) {
        this.triggerRect = trigger.getBoundingClientRect();
      }
    },
    onToggle(id) {
      const current = [...this.modelValue];
      const idx = current.indexOf(id);
      if (idx === -1) {
        current.push(id);
      } else {
        current.splice(idx, 1);
      }
      this.$emit("update:modelValue", current);
    },
    removeOperator(id) {
      const current = this.modelValue.filter((v) => v !== id);
      this.$emit("update:modelValue", current);
    },
    getEmail(id) {
      const op = this.operators.find((o) => o.id === id);
      return op ? op.email : `ID: ${id}`;
    },
    onOutsideClick(e) {
      const inWrapper = this.$refs.wrapper?.contains(e.target);
      const inDropdown = this.$refs.dropdown?.contains(e.target);
      if (!inWrapper && !inDropdown) {
        this.showDropdown = false;
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onOutsideClick);
    window.addEventListener("scroll", this.updateTriggerRect, true);
    window.addEventListener("resize", this.updateTriggerRect);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
    window.removeEventListener("scroll", this.updateTriggerRect, true);
    window.removeEventListener("resize", this.updateTriggerRect);
  },
};
</script>

<style scoped>
.operators-multiselect {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.operators-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  min-width: 200px;
  user-select: none;
  font-size: 14px;
}

.operators-trigger.open {
  border-color: #666;
}

.operators-arrow {
  margin-left: 8px;
  font-size: 12px;
  color: #666;
}

.operators-dropdown {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  max-height: 240px;
  overflow-y: auto;
  padding: 4px 0;
}

.operators-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.operators-option:hover {
  background: #f5f5f5;
}

.operators-option input[type="checkbox"] {
  cursor: pointer;
}

.operators-empty {
  padding: 8px 12px;
  font-size: 13px;
  color: #888;
}

.operators-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.operators-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e8eaf6;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 12px;
}

.operators-tag-remove {
  background: none;
  border: none;
  border-radius: 4px;
  padding: 2px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  color: #555;
}

.operators-tag-remove:hover {
  background: #e8eaf6;
  color: #c00;
}

@media (max-width: 505px) {
  .operators-tag-remove {
    border-radius: 4px !important;
    line-height: 2 !important;
    color: black !important;
    /* background: black !important; */
    font-size: 13px !important;
    font-weight: 600 !important;
    font-family: "Nunito Sans", sans-serif !important;
    cursor: pointer !important;
    margin: 10px 0 0 0 !important;
    padding: 0px 5px !important;
  }
}
</style>
